import gql from "graphql-tag";

export default gql`
  query getUploadUrlsByToken($token_type: String!, $token: String!, $folder: String!, $fileExtensions: [String!]!) {
    getUploadUrlsByToken(token_type: $token_type, token: $token, folder: $folder, fileExtensions: $fileExtensions)
  }
`;
